export const PROMPT_DOCUMENTATION_OUTPUT = `
Keep the saved answer short, concise, and generalized, so it can help others in similar situations. Summarize the key point clearly, include facts and numbers exactly as they are, and add links to relevant sources or tools if available.
`.trim();
